import React, { type FC } from 'react';
import clsx from 'clsx';
import { isEqual } from 'lodash-es';
import { RegularBadgeLabel } from '@is24at/react-enums';
import { AiText } from '@is24at/react-ui-core/src/components/AiText/AiText';
import { type Augmentation } from 'server/types/graphql';
import styles from './Badge.scss';

interface BadgeProps {
  label: string;
  augmentation?: Augmentation;
}

const Badge: FC<BadgeProps> = ({ label, augmentation }) =>
  augmentation ? (
    <AiText
      text={label}
      className={clsx(
        styles.badge,
        isEqual(label, RegularBadgeLabel.NEW) ? styles.teal : styles.gray,
      )}
      data-testid="augmented-badge"
    />
  ) : (
    <span
      className={clsx(
        styles.badge,
        isEqual(label, RegularBadgeLabel.NEW) ? styles.teal : styles.gray,
      )}
    >
      {label}
    </span>
  );

export default Badge;
